import { merge } from 'lodash';
import { varFade, varSlide } from 'src/components/animate';

const durationIn = 0.275;
export const transition = merge(
  varFade({ durationIn }).in,
  varSlide({ distance: 24, durationIn }).inUp,
);
